'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

var _bControl = (require('./../../control/control.react.js'), (require('./../../../desktop.blocks/control/control.react.js').default || require('./../../../desktop.blocks/control/control.react.js')).applyDecls());

var _bControl2 = _interopRequireDefault(_bControl);

var _eBox = (require('./../__box/radiobox__box.react.js').default || require('./../__box/radiobox__box.react.js')).applyDecls();

var _eBox2 = _interopRequireDefault(_eBox);

var _eControl = (require('./../__control/radiobox__control.react.js').default || require('./../__control/radiobox__control.react.js')).applyDecls();

var _eControl2 = _interopRequireDefault(_eControl);

var _eText = (require('./../__text/radiobox__text.react.js').default || require('./../__text/radiobox__text.react.js')).applyDecls();

var _eText2 = _interopRequireDefault(_eText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)(_bControl2.default, {
    block: 'radiobox',
    elem: 'radio',
    tag: 'label',
    attrs: function attrs(_ref) {
        var _ref$id = _ref.id,
            htmlFor = _ref$id === undefined ? this.generateId() : _ref$id;

        return _extends({}, this.__base.apply(this, arguments), {
            htmlFor: htmlFor
        });
    },
    mods: function mods(_ref2) {
        var disabled = _ref2.disabled,
            mainDisabled = _ref2.mainDisabled,
            value = _ref2.value,
            mainValue = _ref2.mainValue,
            checked = _ref2.checked;

        return _extends({}, this.__base.apply(this, arguments), {
            disabled: this.__self.bool2string(disabled || mainDisabled),
            checked: this.__self.bool2string(this._isChecked(value, mainValue, checked))
        });
    },
    content: function content(_ref3) {
        var _ref3$id = _ref3.id,
            id = _ref3$id === undefined ? this.generateId() : _ref3$id,
            name = _ref3.name,
            mainDisabled = _ref3.mainDisabled,
            disabled = _ref3.disabled,
            value = _ref3.value,
            checked = _ref3.checked,
            mainValue = _ref3.mainValue,
            children = _ref3.children;

        return [_react2.default.createElement(
            _eBox2.default,
            { key: 'box' },
            _react2.default.createElement(_eControl2.default, {
                name: name,
                id: id,
                value: value,
                checked: this._isChecked(value, mainValue, checked),
                onChange: this.props.onChange,
                disabled: disabled || mainDisabled
            })
        ), _react2.default.createElement(
            _eText2.default,
            { key: 'text' },
            children
        )];
    },
    _isChecked: function _isChecked(value, mainValue, checked) {
        return checked || value !== undefined && value === mainValue;
    }
}, {
    propTypes: {
        disabled: _propTypes2.default.bool,
        name: _propTypes2.default.string,
        id: _propTypes2.default.string,
        mainDisabled: _propTypes2.default.bool,
        checked: _propTypes2.default.bool,
        mainValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
    }
});